import { useState } from "react";
import { Menu, X } from "lucide-react";
import { SITE } from "@/lib/site";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Menu", href: "#menu" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#FAF7F2]/90 border-b border-[#E5DFD3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex flex-col leading-none"
        >
          <span className="font-serif-display text-2xl md:text-3xl font-semibold text-[#2C2621] tracking-tight">
            Kingston Coffee Co.
          </span>
          <span className="text-[10px] uppercase tracking-[0.25em] text-[#8B5E3C] font-semibold mt-0.5">
            Mobile Catering
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-[#594D42] hover:text-[#8B5E3C] transition-colors"
            >
              {n.label}
            </a>
          ))}
          <a
            href="#quote"
            data-testid="header-cta-quote"
            className="bg-[#8B5E3C] text-white rounded-md px-5 py-2.5 text-sm font-semibold transition-all duration-300 hover:bg-[#70482B] hover:-translate-y-0.5 hover:shadow-md"
          >
            Request a Quote
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#2C2621]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} strokeWidth={1.5} /> : <Menu size={26} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden backdrop-blur-xl bg-[#FAF7F2]/95 border-b border-[#E5DFD3] px-6 py-6 flex flex-col gap-4"
        >
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-[#594D42] hover:text-[#8B5E3C]"
            >
              {n.label}
            </a>
          ))}
          <a
            href="#quote"
            onClick={() => setOpen(false)}
            className="bg-[#8B5E3C] text-white rounded-md px-5 py-3 text-center text-sm font-semibold"
          >
            Request a Quote
          </a>
        </div>
      )}
    </header>
  );
};
